import React from "react";
import PropTypes from "prop-types";

const HighlyConfidentialIcon = (props) => {
  const { width = "86", height = "86" } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 86 86"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M64 43C64 54.598 54.598 64 43 64C31.402 64 22 54.598 22 43C22 31.402 31.402 22 43 22C54.598 22 64 31.402 64 43ZM26.199 43C26.199 52.279 33.721 59.801 43 59.801C52.279 59.801 59.801 52.279 59.801 43C59.801 33.721 52.279 26.199 43 26.199C33.721 26.199 26.199 33.721 26.199 43Z"
        fill="#FE0000"
      />
      <path
        d="M72.7561 42.9999C72.7561 59.4337 59.4339 72.7559 43.0001 72.7559C26.5664 72.7559 13.2441 59.4337 13.2441 42.9999C13.2441 26.5661 26.5664 13.2439 43.0001 13.2439C59.4339 13.2439 72.7561 26.5661 72.7561 42.9999ZM19.1939 42.9999C19.1939 56.1477 29.8523 66.8062 43.0001 66.8062C56.148 66.8062 66.8064 56.1477 66.8064 42.9999C66.8064 29.8521 56.148 19.1936 43.0001 19.1936C29.8523 19.1936 19.1939 29.8521 19.1939 42.9999Z"
        fill="#FE0000"
      />
    </svg>
  );
};

HighlyConfidentialIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default HighlyConfidentialIcon;
